import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import BaseActivityCard from '@alltrails/shared/components/ActivityCard';
import { useAppSelector } from '../../redux';
import useAdminCTAs from '../../hooks/useAdminCTAs';
import useAdminTrackLinks from './useAdminTrackLinks';
import { AdminTrackHit, trackHitToActivity } from './utils';

type ActivityCardProps = {
  currentResult: AdminTrackHit;
  setIsPopupHovered: (isPopupHovered: boolean) => void;
};

const ActivityCard = ({ currentResult, setIsPopupHovered }: ActivityCardProps) => {
  const languageRegionCode = useLanguageRegionCode();
  const displayMetric = useAppSelector(state => state.context.displayMetric);
  const adminTrackLinks = useAdminTrackLinks(currentResult);
  const adminCTAs = useAdminCTAs(adminTrackLinks);

  return (
    <BaseActivityCard
      languageRegionCode={languageRegionCode}
      openInNewTab
      onCardMouseEnter={() => setIsPopupHovered(true)}
      onCardMouseLeave={() => setIsPopupHovered(false)}
      variant="small"
      activity={trackHitToActivity(currentResult as AdminTrackHit)}
      useMetric={!!displayMetric}
      adminCTAs={adminCTAs}
      showActivityType
    />
  );
};

export default ActivityCard;
